export var SET_REGION = 'set current region';
export var SET_EXPECTED_REGIONS = 'set expected regions';
export var SET_ALL_REGIONS_LIST = 'set all regions list';
export var SHOULD_CONFIRM_REGION = 'should confirm region';
export var APPROVE_REGION = 'approve region';
export var OPEN_REGION_LIST = 'open region list';
export var SET_LOGIN_MODEL = 'set login model';
export var SET_HIDDEN_FIELDS = 'set hidden fields';
export var SET_FEEDBACK_MODEL = 'set feedback model';
export var SET_CURRENT_CTN = 'set current ctn';
export var SET_CTN_LIST = 'set ctn list';
export var SET_ERROR = 'error popup show';
export var SET_LOCALE = 'set page locale';
export var SET_MOBILE_ID_DATA = 'set mobile id data';
export var SET_SEARCH_QUERY = 'set search query';
export var SET_CORRECTION_QUERY = 'set correction query';
export var SET_IS_SEND_ANALYTICS = 'set is send analytics';
export var SET_AUTH = 'set auth';

/* fetch cart total product num */
export var FETCH_CART_STATS_SUCCESS = 'fetch cart stats success';
export var CREATE_CART_API = 'create cart api';
export var SET_CART_DATA = 'set cart data';